import { DateTime } from 'luxon';
import { useContext } from 'react';
import {
    Body,
    ColumnContent,
    Container,
    LeftColumn,
    RightColumn,
} from '../ui/layout/SingleContent.tsx';
import { css } from '@emotion/css';
import { ColorHex } from '../ui/Colors.ts';
import { OperatorContext } from '../app/components/BaseLayoutAndData.tsx';
import { urlWithOperatorExternalId } from '../utils/Utils.ts';

export function SpecialReports() {
    const { operatorExternalId } = useContext(OperatorContext);

    const year = DateTime.now().year;
    const years = [year, year - 1, year - 2];
    return (
        <Container>
            <Body disabled={false} slideIns={[]}>
                <ColumnContent>
                    <LeftColumn>
                        {years.map(y => {
                            return (
                                <a
                                    key={y}
                                    className={css({
                                        color: ColorHex.typo,
                                        display: 'block',
                                        marginBottom: '8px',
                                        textDecoration: 'none',
                                        '&:hover': {
                                            color: ColorHex.lightblue,
                                        },
                                    })}
                                    target="_blank"
                                    href={urlWithOperatorExternalId(
                                        `/ui-api/operator-account/park-transactions/exports/mobility-report-csv?` +
                                            `from=${y}-01-01&to=${y}-12-31`,
                                        operatorExternalId,
                                    )}
                                    rel="noreferrer"
                                >
                                    {'Mobilitätsauswertung ' + y}
                                </a>
                            );
                        })}
                    </LeftColumn>
                    <RightColumn />
                </ColumnContent>
            </Body>
        </Container>
    );
}
